import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAlarmIdRepresentation } from '../../../reducers/userDetailsSlice';
import {
  ALARM_ID_DECIMAL,
  ALARM_ID_HEXADECIMAL,
  ALARM_ID_REPRESENTATION_KEY,
} from '../../../common/constants';
import { useLelyAuth } from '../../../auth/useLelyAuth';

function useAlarmIdRepresentation() {
  const dispatch = useDispatch();

  const username = useLelyAuth().user?.email;

  useEffect(() => {
    if (username) {
      const storedRepresentation = getStoredRepresentation(username);

      if (storedRepresentation) {
        dispatch(setAlarmIdRepresentation(storedRepresentation));
      } else {
        dispatch(setAlarmIdRepresentation(ALARM_ID_DECIMAL));
        setStoredRepresentation(username, ALARM_ID_DECIMAL);
      }
    }
  }, [username]);
}

export const getStorageKey = (username: string) =>
  `${ALARM_ID_REPRESENTATION_KEY}_${username}`;

const getStoredRepresentation = (
  username: string,
): typeof ALARM_ID_HEXADECIMAL | typeof ALARM_ID_DECIMAL => {
  const stored = localStorage.getItem(getStorageKey(username));
  return stored as typeof ALARM_ID_HEXADECIMAL | typeof ALARM_ID_DECIMAL;
};

export const setStoredRepresentation = (
  username: string,
  value: typeof ALARM_ID_HEXADECIMAL | typeof ALARM_ID_DECIMAL,
) => {
  localStorage.setItem(getStorageKey(username), value);
};

export default useAlarmIdRepresentation;
